import React from "react"
import PropTypes from "prop-types"
import Tooltip from "app/static/frontend/components/Tooltip"
import classNames from "classnames"

/**
 * Component to render a column's name
 */
export function ResourceTableColumnName({
    canRenameColumns,
    columnName,
    columnNameTooltip,
    handleRenameColumn,
}) {
    const renderName = () => (
        <div
            className={classNames(
                "column-name-text",
                { "column-name-pointer": canRenameColumns || columnNameTooltip }
            )}
            onClick={handleRenameColumn}
            style={{ flexGrow: 0 }}
        >
            {columnName ? `${columnName}` : "Untitled"}
        </div>
    )

    return (columnNameTooltip)
        ? (
            <Tooltip label={columnNameTooltip}>
                {renderName()}
            </Tooltip>
        )
        : renderName()
}

ResourceTableColumnName.propTypes = {
    canRenameColumns: PropTypes.bool,
    columnName: PropTypes.string,
    columnNameTooltip: PropTypes.string,
    handleRenameColumn: PropTypes.func,
}

export default ResourceTableColumnName
